export const frCollections = {
    'navbar.collections': 'Collections',
    'collections.name': 'Collection',

    //* COLLECTION LIST
    'collections.list.pageTitle': 'Collections',
    'collections.title': 'Collections',
    'collections.list.actions.addCollection': 'Créer une collection',
    'collections.list.table.emptyLabel': "Il n'y a pas de collection pour le moment",

    //* COLLECTION INFORMATIONS
    'collections.info.title': 'TITRE *',
    'collections.info.description': 'Saisissez ici la description du collection',
    'collections.info.owner.select.title': 'Sélectionnez le propriètre du collection',

    //* COLLECTION NOTIFICATIONS // MANUAL
    'collections.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté la collection.",

    //* COLLECTION PRODUCTS
    'collections.product.remove.title': "Suppression d'un produit",
    'collections.product.remove.content': 'Êtes-vous sûr de vouloir supprimer ce produit ?',

    'collections.products.remove.title': 'Suppression de tous les produits',
    'collections.products.remove.content': 'Êtes-vous sûr de vouloir supprimer tous les produits ?',

    'collections.products.emptyLabel': 'Aucun produit pour le moment.',
    'collections.products.actions.add': 'Ajouter un produit',

    //*  COLLECTION PRODUCT DIALOG
    'collections.productDialog.hintName': 'Titre du produit *',
    'collections.productDialog.hintRef': 'Référence du produit',
    'collections.productDialog.hintDescription': 'Saisissez ici la description du produit',

    //* COLLECTION >> CREATE AND DETAILS
    'collections.create.pageTitle': 'Création collection',
    'collections.details.pageTitle': 'Détails collection',
    'collections.details.actions.previous': 'Collections',

    'collections.remove.dialog.title': 'Suppression de la collection',
    'collections.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer cette collection ?',

    //* COLLECTION DETAILS //TABS //RESULTS
    'collections.details.results.filters.shop.label': 'Centre',
    'collections.details.results.filters.favoriteShops': 'Mes magasins favoris',
    'collections.details.results.filters.apply': 'Appliquer',
    'collections.details.results.tableHeader.productName': 'Produit',
    'collections.details.results.tableHeader.likeCount': "Nombre total de j'aime",
    'collections.details.results.emptyLabel': 'Aucun résultat pour le moment.',

    //* COLLECTION PERMISSIONS
    'backofficeUsers.permissions.collections.contentcreate': 'Création de collection',

    //* ERRORS
    'toast.apiErrors.COLLECTION_MUST_HAVE_ONE_PRODUCT_AT_LEAST': 'Une collection doit avoir au moins un produit',
};
